import styled from "styled-components";

import { Fonts } from "assets/fonts";
import { ArrowIcon } from "assets/icons";

/** From boost-react-weabapp, updated on 08.03.2023 */

const StyledColumnHeader = styled.th<{ $hidden: boolean; sortingEnabled?: boolean }>`
  position: sticky;
  z-index: 20;
  padding: 0 8px;
  background-color: inherit;
  ${Fonts.SEMIBOLD_12}
  line-height: 1.2em;
  color: ${(p) => p.theme.textMediumContrast};
  text-align: left;
  ${(p) => p.sortingEnabled && "cursor: pointer;"}
  ${(p) => p.$hidden && "display: none;"};

  &:first-child {
    padding-left: 16px;
  }
  &:last-child {
    padding-right: 16px;
  }
  &:first-child::before,
  &:last-child::after {
    display: block;
    content: "";
    width: 20px;
    height: 100%;
    background-color: inherit;
    position: absolute;
    top: 0;
  }
  &:first-child::before {
    left: -16px;
  }
  &:last-child::after {
    right: -16px;
  }
`;

const SortIcon = styled(ArrowIcon)<{ $ascending: boolean }>`
  position: absolute;
  top: 50%;
  margin-left: 8px;
  transform: translateY(-50%) ${(p) => !p.$ascending && "rotate(180deg)"};
  color: ${(p) => p.theme.textHighestContrast};
`;

export type SortingDirection = "asc" | "desc";

interface ColumnHeaderProps {
  className?: string;
  hidden?: boolean;
  onClick?: (direction: SortingDirection) => void;
  sortingDirection?: SortingDirection;
  sortingEnabled?: boolean;
  renderTitle: () => React.ReactNode;
  title: string;
}
export const ColumnHeader = (props: ColumnHeaderProps) => {
  const {
    className,
    hidden = false,
    onClick,
    sortingDirection,
    sortingEnabled,
    renderTitle,
    title,
  } = props;
  return (
    <StyledColumnHeader
      className={className}
      $hidden={hidden}
      sortingEnabled={sortingEnabled}
      title={`${title}${sortingDirection ? `: sorted ${sortingDirection}ending` : ""}`}
      scope="col"
      onClick={() => onClick && onClick(sortingDirection === "asc" ? "desc" : "asc")}
    >
      {renderTitle()}
      {sortingDirection && <SortIcon $ascending={sortingDirection === "asc"} />}
    </StyledColumnHeader>
  );
};
